
import { defineComponent } from "vue";

export default defineComponent({
  name: "MenuLateral",
  emits: ["aoTemaAlterado"],
  data() {
    return {
      modoEscuroAtivo: false,
    };
  },
  computed: {
    /**
     * Exibe Texto no Botão de Acordo com o Estado do Botão
     *@description
     *26/07/2022 vlima Exibir Texto no Botão
     */
    textButton() {
      if (this.modoEscuroAtivo) {
        return "Desativar modo Escuro";
      }
      return "Ativar modo Escuro";
    },
  },
  methods: {
    /**
     * Inverte o Estado do Botão ao Clique do Usere passa  como emit
     *@description
     *26/07/2022 vlima Toggle Tema
     */
    toggleTema() {
      this.modoEscuroAtivo = !this.modoEscuroAtivo;
      this.$emit("aoTemaAlterado", this.modoEscuroAtivo);
    },
  },
});
